import { Grid, Typography } from '@mui/material';
import { Control } from 'react-hook-form';
import { shuffle } from 'lodash';
import { useSelector } from 'react-redux';
import { PatientInput } from '../../../generated/graphql';
import { DemographicFormValues } from './demographics-form';
import { DISCOVERY_CHANNEL_OPTIONS } from '../../../helpers/const';
import {
  AssessmentCard,
  ControlledSelectField,
  ControlledTextField,
} from '../shared';
import { selectLdFlags } from '../../../redux/ld-flags';
import { PersonalDetailFormValues } from './personal-details';

type PropTypes = {
  control:
    | Control<DemographicFormValues, any>
    | Control<PersonalDetailFormValues, any>;
  patient: PatientInput;
  isVisible: boolean;
  showOtherField: boolean;
};

export const DemographicsDiscovery = ({
  control,
  patient,
  isVisible,
  showOtherField,
}: PropTypes) => {
  const { shouldUseIntakeV2Point1 } = useSelector(selectLdFlags);

  return (
    isVisible &&
    (shouldUseIntakeV2Point1 ? (
      <AssessmentCard>
        <Grid container rowSpacing={2}>
          <Grid item xs={12}>
            <Typography component="h3" variant="h5">
              Where did you hear about us? (optional)
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <ControlledSelectField<DemographicFormValues>
              name="discoveryChannel"
              control={control}
              defaultValue={patient.discoveryChannel ?? ''}
              options={shuffle(DISCOVERY_CHANNEL_OPTIONS).map(option => ({
                label: option,
                value: option,
              }))}
              label="Select"
            />
          </Grid>
          {showOtherField && (
            <Grid item xs={12}>
              <ControlledTextField<DemographicFormValues>
                name="discoveryChannelOther"
                control={control}
                defaultValue=""
                autoComplete="off"
                label=""
                inputProps={{ maxLength: 500 }}
                placeholder="Please explain"
                showCharCount
              />
            </Grid>
          )}
        </Grid>
      </AssessmentCard>
    ) : (
      <AssessmentCard>
        <Grid container rowSpacing={2}>
          <Grid item xs={12}>
            <ControlledSelectField<DemographicFormValues>
              name="discoveryChannel"
              control={control}
              defaultValue={patient.discoveryChannel ?? ''}
              options={shuffle(DISCOVERY_CHANNEL_OPTIONS).map(option => ({
                label: option,
                value: option,
              }))}
              label="Where did you first hear about us? (optional)"
            />
          </Grid>
          {showOtherField && (
            <Grid item xs={12}>
              <ControlledTextField<DemographicFormValues>
                name="discoveryChannelOther"
                control={control}
                defaultValue=""
                autoComplete="off"
                label=""
                inputProps={{ maxLength: 500 }}
                placeholder="Please explain"
                showCharCount
              />
            </Grid>
          )}
        </Grid>
      </AssessmentCard>
    ))
  );
};
